!function() {
  "use strict";
  customElements.get("custom-cursor") || customElements.define("custom-cursor", class extends HTMLElement {
    cursor=this.querySelector("div");
    target=this.dataset.target;
    constructor() {
      super();
    }
    on(s, t) {
      s.classList.add("!cursor-none"), this.cursor.style.left = `${t.clientX}px`, this.cursor.style.top = `${t.clientY}px`, 
      this.cursor.classList.remove("scale-0");
    }
    off(s) {
      this.cursor.classList.add("scale-0"), s.classList.remove("!cursor-none");
    }
    bind() {
      (this.closest(".shopify-section") || document.body).querySelectorAll(this.target).forEach((s => {
        s.addEventListener("mouseenter", (t => this.on(s, t))), s.addEventListener("mousemove", (t => this.on(s, t))), 
        s.addEventListener("mouseleave", (() => this.off(s)));
      }));
    }
    connectedCallback() {
      this.cursor && this.target && this.bind();
    }
  });
}();